import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'map-west', 'MapWest', [["path",{"d":"M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"}],["path",{"d":"M9 9l1 6l2 -3.75l2 3.75l1 -6"}]]);